import { SpinnerSize, WithCommonProps } from '@shipengine/giger';
import { getFullscreenSpinnerStyles } from './FullscreenSpinnerStyles';
import { Spinner } from './Spinner';

export type FullscreenSpinnerProps = WithCommonProps<unknown>;

export function FullscreenSpinner(props: FullscreenSpinnerProps): JSX.Element {
    return (
        <div css={getFullscreenSpinnerStyles} {...props}>
            <Spinner size={SpinnerSize.SIZE_LARGE} />
        </div>
    );
}
